<script setup lang="ts">
// COMPOSABLES
const { tt } = useTypedI18n();
const { phones, pec } = useFleequidContacts();
</script>

<template>
    <div class="flex flex-col gap-2 text-xs">
        <h4 class="font-semibold">{{ tt('footer.support') }}</h4>
        <div v-for="phone in phones" :key="phone" class="flex gap-1">
            <UIcon class="size-4" name="lucide:phone" />
            <BasePhoneLink class="text-inherit" :phone="phone" />
        </div>
        <div v-if="pec" class="flex gap-1">
            <UIcon class="size-4" name="lucide:mail-check" />
            <BaseEmailLink class="text-inherit" :email="pec">{{ pec }}</BaseEmailLink>
        </div>
        <div class="flex gap-1">
            <UIcon class="size-4" name="lucide:mail" />
            <FleequidEmailLink class="text-inherit" type="sales" />
        </div>
        <div class="flex gap-1">
            <UIcon class="size-4" name="lucide:mail" />
            <FleequidEmailLink class="text-inherit" type="customerService" />
        </div>
        <FleequidWhatsappLink />
    </div>
</template>
